export const communitydata = [
  {
    profie: "",
    coverImg: "",
    name: "Swing Traders",
    desc: "A community for swingers alone",
    id: "09772gjklid",
    slug: "swing-traders",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "Swing Traders",
    desc: "A community for swingers alone",
    id: "09772gjklid",
    slug: "swing-traders",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
  {
    profie: "",
    coverImg: "",
    name: "US30 Community",
    desc: "A community for u30 kings",
    id: "0977jdhi09dd",
    slug: "us30-community",
  },
];

export const memebersdata = [
  { name: "Kingrashy", isAdmin: true },
  { name: "Kingrashy", isAdmin: true },
  { name: "Kingrashy", isAdmin: true },
  { name: "Kingrashy", isAdmin: true },
  { name: "Kingrashy", isAdmin: true },
  { name: "Kingrashy", isAdmin: true },
  { name: "Kingrashy", owner: true },
];
